/**
 * Vendor JavaScript
 */

import 'jquery';
import 'slick-carousel';
import 'jquery-mask-plugin';

// Make jQuery available globally
window.$ = window.jQuery = require('jquery');

// Import Slick Carousel CSS
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

